export default {"src":"/_next/static/media/Mobile.d778f496.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};